import { render, staticRenderFns } from "./CompanyShiftActionsButton.vue?vue&type=template&id=854b716e&"
import script from "./CompanyShiftActionsButton.vue?vue&type=script&lang=js&"
export * from "./CompanyShiftActionsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports